import { createFileRoute } from '@tanstack/react-router'
import { ConfigSelection } from 'pages/productionDashboard/ConfigSelection'

export const Route = createFileRoute('/production-dashboard/$orgID/$siteID/')({
  component: ConfigSelectionRouteComponent,
  staticData: {
    title: 'Production Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})

function ConfigSelectionRouteComponent() {
  const params = Route.useParams()
  return <ConfigSelection {...params} />
}
